<template>
  <v-text-field
    :label="metadata.title"
    v-bind:value="value"
    v-on:input="$emit('input', $event)"
    :prefix="metadata.name === 'projectedRoi' ? '%' : ''"
  ></v-text-field>
</template>

<script>
  export default {
    name: "MetaFieldNumber",

    props: [
      'value',
      'metadata'
    ],

    data: () => ({
    }),

    methods: {
    }
  }
</script>
